import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, Container, LinearProgress, Stack, Typography } from '@mui/material';
import { interviewRequest } from './api/journeyBotApi';

export default function InterviewInvitationPage() {
  const { invitationId } = useParams();
  const [path, setPath] = useState('');
  const [error, setError] = useState('');
  const claiming = useRef(false);
  const claim = useCallback(async () => {
    if (claiming.current) return;
    claiming.current = true; setError('');
    try {
      const result = await interviewRequest(`/invitations/${encodeURIComponent(invitationId)}/claim`, {});
      setPath(result.path);
    } catch (claimError) {
      setError(claimError.message || 'This invitation could not be opened.');
      claiming.current = false;
    }
  }, [invitationId]);
  useEffect(() => { claim(); }, [claim]);
  if (path) return <Navigate to={path} replace />;
  return <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', color: 'text.primary' }}>
    <Container maxWidth="sm" sx={{ py: 5, textAlign: 'left' }}><Stack spacing={2}>
    <Typography variant="h4" component="h1">Opening your interview</Typography>
    {!error && <><LinearProgress /><Typography role="status">Checking this invitation and preparing your private interview…</Typography></>}
    {error && <><Alert severity="error">{error}</Alert><Button variant="outlined" onClick={claim}>Try again</Button></>}
    </Stack></Container>
  </Box>;
}
